import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BusyServiceDisablingMarker } from '../../../../../../api-generator/static/request-builder';

@Injectable({
  providedIn: 'root'
})
export class HttpHelperService {
  httpHeadersDisableLoader: HttpHeaders;

  constructor(
  ) {
    this.httpHeadersDisableLoader = new HttpHeaders();
    this.httpHeadersDisableLoader = this.httpHeadersDisableLoader.append(BusyServiceDisablingMarker, 'true');
  }

  getHeadersWithDisabledLoader() {
    return this.httpHeadersDisableLoader
  }
}
